module.exports = __webpack_public_path__ + "img/fig39.ab935490.jpg";